import React, {Component} from "react";
import {TripDetailView} from "./TripDetailView";
import {bindActionCreators} from "redux";
import {fetchFullRide} from "../../store/ride/actions";
import {selectRide} from "../../store/ride/reducer";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import moment from "moment-jalaali";


class TripDetail extends Component{
    constructor(props) {
        super(props);
        moment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})
    }
    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.fetchFullRide(id);
    }

    render() {
        return <TripDetailView ride={this.props.ride}/>
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchFullRide,
    },
    dispatch);

const mapStateToProps = state => ({
    ride: selectRide(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TripDetail))